import React from 'react';
import {Route, Redirect} from 'react-router-dom';
export const Guard = ({component:Component, token:Token, routeRedirect,edit:Edit,...rest}) => (
  <Route {...rest} render={props=> (
    sessionStorage.getItem(Token) ?<Component {...props} abc={Edit}/>
      : 
      <Redirect to={{pathname:routeRedirect, state:{from:props.location}}} />
  )}/>
)
